import { useCallback, useEffect, useState } from 'react';
import { startVisitAnalytics } from '../analytics/visitAnalytics';

const COOKIE = 'ca_analytics_consent';
const MAX_AGE = 365 * 24 * 60 * 60;

function readConsent() {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return null;
  }
}

function writeConsent(value) {
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${COOKIE}=${encodeURIComponent(value)};path=/;max-age=${MAX_AGE};SameSite=Lax${secure}`;
}

/**
 * Cookie consent for optional analytics (first-party cookie + session storage). No measurement until accept.
 */
export default function AnalyticsConsent() {
  const [consent, setConsent] = useState(() =>
    typeof document !== 'undefined' ? readConsent() : null
  );

  useEffect(() => {
    if (consent !== '1') return undefined;
    const stop = startVisitAnalytics();
    return () => {
      if (typeof stop === 'function') stop();
    };
  }, [consent]);

  const accept = useCallback(() => {
    writeConsent('1');
    setConsent('1');
  }, []);

  // const decline = useCallback(() => {
  //   writeConsent('0');
  //   setConsent('0');
  // }, []);

  if (consent !== null) return null;

  return (
    <div className="ca-analytics-consent" role="dialog" aria-labelledby="ca-analytics-consent-title">
      <div className="ca-analytics-consent__box">
        <p id="ca-analytics-consent-title" className="ca-analytics-consent__title">
          Cookies on this site
        </p>
        <p className="ca-analytics-consent__text">
          We use cookies to remember your choices and to measure how the site is used. By clicking “Accept
          cookies” you agree to our use of cookies for these purposes. You can decline non-essential cookies
          and the site will still work.
        </p>
        <div className="ca-analytics-consent__actions">
          <button type="button" className="ca-btn ca-btn--ghost ca-analytics-consent__btn" onClick={accept}>
            Decline cookies
          </button>
          <button type="button" className="ca-btn ca-btn--primary ca-analytics-consent__btn" onClick={accept}>
            Accept cookies
          </button>
        </div>
      </div>
    </div>
  );
}
